import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import ProfileIndex from 'src/Patient/edit/Index'
import ReservationPatient from 'src/Patient/Reservations/Index'


export const DashboardRoutes = () => {
    const rootPathServer = process.env.REACT_APP_ROOT_SERVER_PATH;
    return (
        <Switch>
            <Route exact path={`${rootPathServer}/paciente/editar`} component={ProfileIndex} />
            <Route exact path={`${rootPathServer}/paciente/reservas`} component={ReservationPatient} />
            <Redirect from="/" to={`${rootPathServer}/paciente/reservas`} />
        </Switch>
    )
}